import { createSlice } from '@reduxjs/toolkit';
import { getUserThunk } from '../../user/thunk/user.thunk';

const initialState = {
  isLoading: false,
  result: null,
  error: null,
};

export const meSlice = createSlice({
  name: 'me',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserThunk.pending, (state) => ({
        ...state,
        isLoading: true,
        error: null,
      }))
      .addCase(getUserThunk.fulfilled, (state, { payload }) => ({
        isLoading: false,
        result: payload,
        error: null,
      }))
      .addCase(getUserThunk.rejected, (state, { payload }) => ({
        ...state,
        isLoading: false,
        error: payload,
      }));
  },
});
